import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Results from "./pages/Results";
import ProviderDetail from "./pages/ProviderDetail";
import Profile from "./pages/Profile";
import { getSession } from "./lib/auth";
import { ThemeProvider } from "./lib/theme";
import DeviceRestrictionWrapper from "./components/DeviceRestrictionWrapper";

function Protected({ children }) {
  return getSession() ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <DeviceRestrictionWrapper>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/home" element={<Protected><Home /></Protected>} />
              <Route path="/servicos/:service" element={<Protected><Results /></Protected>} />
              <Route path="/prestador/:placeId" element={<Protected><ProviderDetail /></Protected>} />
              <Route path="/perfil" element={<Protected><Profile /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </DeviceRestrictionWrapper>
        <Toaster position="top-center" richColors closeButton />
      </div>
    </ThemeProvider>
  );
}

export default App;

